import React from "react";

const CrossDiv = () => {

    return (
      <React.Fragment>
        <div className='wrapp_cross'>
            <div className='cross'></div>
        </div>
      </React.Fragment>
    );
  };
  
  export default CrossDiv;